<template>
  <div>
    <v-btn
      v-if="addParameter == false"
      color="primary"
      dark
      class="mb-2"
      @click="addParameter = true"
    >
      Добавить
    </v-btn>
    <v-container v-if="addParameter == true">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="dataParametersForm">
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    ref="name"
                    v-model="editedItem.name"
                    label="Наименование"
                    :rules="inputRules"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-autocomplete
                    v-model="editedItem.resource_type"
                    :items="resources_types"
                    label="Тип энергоресурса"
                    item-text="name"
                    item-value="resource_type_id"
                    return-object
                    :menu-props="{maxHeight:'auto'}"
                    :rules="inputRules"
                    required
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    v-model="editedItem.remark"
                    label="Примечание"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click.native="save"
          >
            Сохранить
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="close"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <v-data-table
      v-if="addParameter == false"
      :headers="headers"
      :items="items"
      :search="search"
      :total-items="totalItems"
      :loading="loading"
      class="elevation-1"
      hide-actions
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.resource_type.name }}</td>
        <td>{{ props.item.remark }}</td>
        <td class="justify-center layout px-0">
          <v-btn
            icon
            class="mx-0 my-0"
            @click="editItem(props.item)"
          >
            <v-icon color="teal">
              edit
            </v-icon>
          </v-btn>
          <v-btn
            icon
            class="mx-0 my-0"
            @click="deleteItem(props.item)"
          >
            <v-icon color="pink">
              delete
            </v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
const API_URL = 'data_parameters'
export default {
  name: 'DataParameters',
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      resources_types: [],
      search: '',
      dialog: false,
      totalItems: 0,
      addParameter: false,
      items: [],
      loading: true,
      headers: [
        {
          text: 'Наименование',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Тип энергоресурса',
          align: 'left',
          sortable: true,
          value: 'resource_type'
        },
        { text: 'Замечание', value: 'remark' },
        { text: '', value: '' }
      ],
      editedIndex: -1,
      editedItem: {
        parameter_id: '',
        name: '',
        remark: '',
        resource_type_id: '',
        resource_type: {}
      },
      defaultPlace: {
        parameter_id: '',
        name: '',
        remark: '',
        resource_type_id: '',
        resource_type: {}
      }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Новый тип параметра' : 'Редактирование параметра'
    }
  },

  mounted () {
    this.getItemsApi()
    this.getResourcesTypesApi()
  },
  methods: {
    getResourcesTypesApi () {
      this.loading = true
      axios.get(`/api/resources_types/?page_size=all`)
        .then((response) => {
          this.resources_types = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    getItemsApi () {
      this.loading = true
      axios.get(`/api/${API_URL}/?page_size=all`)
        .then((response) => {
          this.items = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    addItemApi () {
      this.loading = true
      const resourceTypeId = this.editedItem.resource_type.resource_type_id
      this.editedItem.resource_type_id = resourceTypeId
      axios.post(`/api/${API_URL}/`, this.editedItem)
        .then((response) => {
          this.loading = false
          this.items.push(response.body)
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    updateItemApi () {
      this.loading = true
      const id = this.editedItem.parameter_id
      const resourceTypeId = this.editedItem.resource_type.resource_type_id
      this.editedItem.resource_type_id = resourceTypeId
      axios.put(`/api/${API_URL}/${id}/`, this.editedItem)
        .then((response) => {
          this.loading = false
          Object.assign(this.items[this.editedIndex], response.body)
          this.close()
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    deleteItemApi (item) {
      const id = item.parameter_id
      this.loading = true
      axios.delete(`/api/${API_URL}/${id}`)
        .then((response) => {
          this.loading = false
          const index = this.items.indexOf(item)
          this.items.splice(index, 1)
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.addParameter = true
    },
    deleteItem (item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteItemApi(item)
      }
    },
    close () {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultPlace)
        this.editedIndex = -1
      }, 300)
      this.addParameter = false
    },
    validate () {
      if (this.$refs.dataParametersForm.validate()) {
        return true
      }
    },
    save () {
      if (this.validate()) {
        if (this.editedIndex > -1) {
          this.updateItemApi()
        } else {
          this.addItemApi()
        }
        this.addParameter = false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/references/DataParameters.vue